import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useFilterGroup } from '../FilterGroup.Context/index.es.js';

const FilterGroupContent = ({ id, children, classNames: classNames$1, ...props })=>{
    const { currentFilter } = useFilterGroup();
    return currentFilter === id ? jsx("div", {
        className: classNames('filter-group-content', classNames$1),
        ...props,
        children: children
    }) : null;
};
FilterGroupContent.displayName = 'FilterGroup.Content';

export { FilterGroupContent };
//# sourceMappingURL=FilterGroup.Content.es.js.map
